import { z } from 'zod';

export interface GoogleStatus {
  connected: boolean;
  email: string | null;
  error: string | null;
}

export const googleCredentialsSchema = z.object({
  clientId: z.string().trim().min(10).max(300),
  clientSecret: z.string().trim().min(5).max(300),
  refreshToken: z.string().trim().min(10).max(1000),
});
export type GoogleCredentialsInput = z.infer<typeof googleCredentialsSchema>;

export interface GoogleProperties {
  searchConsole: Array<{ siteUrl: string; permission: string }>;
  analytics: Array<{ property: string; name: string; account: string }>;
  business: Array<{ location: string; account: string; title: string; address: string }>;
  errors: string[];
}

export interface GoogleReview {
  id: string;
  channelId: string;
  pageId: string;
  author: string;
  rating: number;
  comment: string;
  createdAt: string;
  reply: string;
  repliedAt: string | null;
  /** Bozza di risposta preparata dall'AI (fase 4). */
  draft: string;
}

export interface MetaPageInfo {
  id: string;
  name: string;
  picture: string;
  instagram: { id: string; username: string } | null;
  updatedAt: string;
}

export interface MetaStatus {
  pages: MetaPageInfo[];
  appConfigured: boolean;
}

export const metaTokenSchema = z.object({ token: z.string().trim().min(20).max(2000) });

export const metaAppSchema = z.object({
  appId: z.string().trim().regex(/^\d{6,20}$/, 'App ID non valido'),
  appSecret: z.string().trim().min(10).max(200),
});
